import { useContext } from 'react';
import { CartContext } from '../context/cartContext';
import { useGuestCart } from '../context/guestCartContext';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import shoppingCart from '../assets/icons/mvr-cart-icon.svg';

function FloatingCartMobile() {
  const { cart } = useContext(CartContext);
  const location = useLocation();

  const isGuestPage = location.pathname.includes('/guest');
  const { user } = useAuth();
  let cartCount = 0;

  if (!user) {
    const { cartCount: guestCartCount } = useGuestCart();
    cartCount = isGuestPage ? guestCartCount : 0;
  } else {
    cartCount = cart?.line_items?.length || 0;
  }

  const cartLink = isGuestPage ? '/guest/cart' : '/cart';

  return (
    <Link to={cartLink} className="relative">
      <div className={'right-12 md:right-10 z-[99]'}>
        <img
          src={shoppingCart || '/placeholder.svg'}
          alt="Cart Icon"
          className=" mx-auto w-3/4"
        />
        {cartCount ? (
          <div
            className="bottom-auto left-auto -right-2 top-1.5 absolute z-10 inline-block -translate-y-full -translate-x-0.5 rotate-0 
        skew-x-0 skew-y-0 scale-x-100 scale-y-100 rounded-full bg-primary-red-300 p-1.5 text-xs"
          ></div>
        ) : (
          <></>
        )}
      </div>
    </Link>
  );
}

export default FloatingCartMobile;
